import { createSlice } from '@reduxjs/toolkit';
import { IAdmin } from '@wot/typings';


interface IInitalState {
  admin: IAdmin,
  error: string,
  loading: boolean
}

const initalState: IInitalState = {
  admin: {
    email: "",
    id: "",
    lastLoggedIn: "",
    role: "admin"
  },
  error: "",
  loading: false
}



const authSlice = createSlice({
  name: "authReducer",
  initialState: initalState,
  reducers: {
    login: (state, { payload }) => {
      state.admin = payload;
    }
  },
  extraReducers(builder) {

  },
})


export const { login } = authSlice.actions


export default authSlice.reducer